import { isEqual, isEmpty } from 'lodash'

const REST_DOMAIN = 'restDomain'
const SECOND_LEVEL_DOMAIN = 'secondLevelDomain'
const PREFIX_BLOB_URL = 'blob:'
const domainReg = new RegExp(`^(?<${REST_DOMAIN}>\\S+)\\.(?<${SECOND_LEVEL_DOMAIN}>[\\w-]+\\.\\w+)$`)

export const getDomain = (hostName: string): string | undefined => {
  const resultGroups = hostName.match(domainReg)?.groups

  return resultGroups && resultGroups[SECOND_LEVEL_DOMAIN]
}

const isDifferentDomain = (domain: string, targetDomain: string): boolean => !isEqual(domain, targetDomain)

function getOriginDomain() {
  let url = location.href

  if (url.startsWith(PREFIX_BLOB_URL)) {
    url = url.slice(PREFIX_BLOB_URL.length)
  }

  return getDomain(new URL(url).hostname)
}

/**
 * switch the domain of the specified url string according to the current location's domain.
 *
 * @param url the url string which will be switched
 * @param originOnly whether to return origin values after switching
 * @return url string after switching or only the origin of the switched result if originOnly is true
 */
function switchDomainImpl(url: string, originOnly: boolean): string {
  if (isEmpty(url)) return url
  const targetUrl = new URL(url.trim())
  const targetDomain = getDomain(targetUrl.hostname)
  const originDomain = getOriginDomain()

  if (targetDomain && originDomain && isDifferentDomain(targetDomain, originDomain)) {
    targetUrl.hostname = targetUrl.hostname.replace(domainReg, `$<${REST_DOMAIN}>.${originDomain}`)
  }

  if (originOnly) {
    return targetUrl.origin
  }

  return targetUrl.toString()
}

export const switchDomain = (url: string): string => switchDomainImpl(url, false)

export const switchOrigin = (url: string): string => switchDomainImpl(url, true)

export const switchDomainName = (url: string, tag: string) => url.replace(/(https:\/\/(?:owork|preowork))/g, '$1' + tag)
